import React, { useEffect, useState } from "react";
import {
  updateDoc,
  doc,
  arrayUnion,
  increment,
  getDocs,
  collection,
} from "firebase/firestore";
import { db } from "../firebase/firestore"; // Import Firestore configuration
import Animate from "../Components/Animate";
import { Outlet } from "react-router-dom";
import { useUser } from "../context/userContext";
import ManualTasks from "../Components/ManualTasks";
import { PiNotebook } from "react-icons/pi";
import { FaBoxes } from "react-icons/fa";
import { IoCheckmarkCircleSharp } from "react-icons/io5";
import { RiArrowRightSLine } from "react-icons/ri";
import Levels from "../Components/Levels";
import SettingsMenu from "../Components/SettingsMenu";
import Referrals from "../Components/Referrals";

const TasksList = () => {
  const {
    id: userId,
    balance,
    setBalance,
    refBonus,
    userLevelss,
    tapBalance,
    selectedCharacter,
    fullName,
    setTasks,
    tasks,
    setEnergy,
    setSpinLimit,
    setMultiplierSpin,
    username,
  } = useUser(); // Assuming 'id' is the user's document ID in Firestore
  const [modalOpen, setModalOpen] = useState(false);
  const [claiming, setClaiming] = useState({});
  const [activeIndex, setActiveIndex] = useState(1);
  const [congrats, setCongrats] = useState(false);
  const [showLevel, setShowLevel] = useState();
  const [showSetting, setShowSetting] = useState(false);
  const [taskLists, setTaskLists] = useState([]);
  const [performedTasks, setPerformedTasks] = useState({});
  const [verifying, setVerifying] = useState({});
  const [modalMessage, setModalMessage] = useState("");

  const handleMenu = (index) => {
    setActiveIndex(index);
  };

  // eslint-disable-next-line react-hooks/exhaustive-deps
  const fetchTasks = async () => {
    const querySnapshot = await getDocs(collection(db, "twitterTasks"));
    const tasksList = querySnapshot.docs.map((doc) => {
      const data = doc.data();
      return {
        id: doc.id,
        ...data,
        // Check if this task is completed by the current user
        isCompleted: data.userCompletions?.[userId]?.completed ?? false,
      };
    });
    setTaskLists(tasksList);
  };
  useEffect(() => {
    fetchTasks();
  }, [fetchTasks]);
  console.log(taskLists, "task");

  const performTask = (taskId) => {
    const task = taskLists.find((task) => task.id === taskId);
    if (task) {
      window.open(task.link, "_blank");
      setTimeout(() => {
        setPerformedTasks((prev) => ({ ...prev, [taskId]: true }));
      }, 3500);
    }
  };

  const verifyTask = async (taskId) => {
    setVerifying((prev) => ({ ...prev, [taskId]: true }));
    try {
      // Create a promise that resolves after 12 seconds
      await new Promise((resolve) => setTimeout(resolve, 12000));
      const userDocRef = doc(db, "telegramUsers", userId);
      await updateDoc(userDocRef, {
        taskLists: arrayUnion({ taskId: taskId, completed: true }),
      });

      // Show success message
      setModalMessage(
        <div className="w-full flex justify-center flex-col items-center space-y-3">
          <div className="w-full items-center justify-center flex flex-col space-y-2">
            <IoCheckmarkCircleSharp size={32} className="text-accent" />
            <p className="font-medium text-center">Verification Successful!</p>
          </div>
          <p className="pb-6 text-[15px] w-full text-center">
            Great job! You can now claim your reward by clicking the claim
            button.
          </p>
        </div>
      );
      setModalOpen(true);

      // Update local state
      setTasks((prev) => [...prev, { taskId, completed: false }]);
    } catch (error) {
      console.error("Error verifying task: ", error);
      setModalMessage(
        <div className="w-full flex justify-center flex-col items-center space-y-3">
          <p className="text-red-500">
            Failed to verify task. Please try again.
          </p>
        </div>
      );
      setModalOpen(true);
    } finally {
      setVerifying((prev) => ({ ...prev, [taskId]: false }));
    }
  };

  const claimTask = async ({ id, slot, cheese, multiplier, roulette }) => {
    setClaiming((prev) => ({ ...prev, [id]: true }));
    try {
      const userDocRef = doc(db, "telegramUsers", userId);
      const taskDoc = doc(db, "twitterTasks", id.toString());

      await updateDoc(userDocRef, {
        // taskLists: tasks.map((task) =>
        //   task.taskId === id ? { ...task, completed: true } : task
        // ),
        spinLimit: increment(Number(slot)),
        multiplierSpin: increment(Number(multiplier)),
        energy: increment(Number(roulette)),
        balance: increment(Number(cheese)),
      });
      console.log("point given");

      await updateDoc(taskDoc, {
        [`userCompletions.${userId}`]: {
          completed: true,
          completedAt: new Date().toISOString(),
        },
      });
      console.log("task updated");

      setSpinLimit((prevSpinLimit) => prevSpinLimit + slot);
      setEnergy((prevEnergy) => prevEnergy + roulette);
      setMultiplierSpin((prevMultiplier) => prevMultiplier + multiplier);
      setBalance((prevBalance) => prevBalance + cheese);
      setTaskLists((prev) =>
        prev.map((t) =>
          t.id === id
            ? {
                ...t,
                userCompletions: {
                  ...t.userCompletions,
                  [userId]: {
                    completed: true,
                    completedAt: new Date().toISOString(),
                  },
                },
              }
            : t
        )
      );

      setModalMessage(
        <div className="w-full flex justify-center flex-col items-center space-y-3">
          <div className="w-full items-center justify-center flex flex-col space-y-2">
            <IoCheckmarkCircleSharp size={32} className="text-accent" />
            <p className="font-medium text-center">Let's go!!</p>
          </div>
          <h3 className="font-medium text-[20px] text-[#ffffff] pt-2 pb-2">
            <p className="font-medium text-center">Task Completed</p>
            {/* Only show reward information if the value is greater than 0 */}
            {(slot > 0 || cheese > 0 || multiplier > 0 || roulette > 0) && (
              <span className="text-accent">
                {slot > 0 && `+${slot} Slot Spins`}
                {slot > 0 &&
                  (cheese > 0 || multiplier > 0 || roulette > 0) &&
                  ", "}
                {cheese > 0 && `+${formatNumberCliam(cheese)} Cheese Points`}
                {cheese > 0 && (multiplier > 0 || roulette > 0) && ", "}
                {multiplier > 0 && `+${multiplier} Multiplier Points`}
                {multiplier > 0 && roulette > 0 && ", "}
                {roulette > 0 && `+${roulette} Roulette Spins`}
                {" rewarded!"}
              </span>
            )}
          </h3>
          <p className="pb-6 text-[15px] w-full text-center">
            Keep performing new tasks! Something huge is coming! Perform more
            and earn more CHEESE now!
          </p>
        </div>
      );
      setModalOpen(true);
      setCongrats(true);

      setTimeout(() => {
        setCongrats(false);
      }, 4000);
    } catch (error) {
      console.error("Error claiming task: ", error);
    } finally {
      setClaiming((prev) => ({ ...prev, [id]: false }));
    }
  };

  const closeModal = () => {
    setModalOpen(false);
  };

  const formatNumber = (number) => {
    if (number === undefined || number === null || isNaN(number)) {
      return "";
    }

    if (number >= 1000000) {
      return (number / 1000000).toFixed() + "M";
    } else if (number >= 100000) {
      return (number / 1000).toFixed(0) + "K";
    } else {
      return number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ");
    }
  };

  const formatNumberCliam = (num) => {
    if (num < 100000) {
      return new Intl.NumberFormat().format(num).replace(/,/g, " ");
    } else if (num < 1000000) {
      return new Intl.NumberFormat().format(num).replace(/,/g, " ");
    } else {
      return (num / 1000000).toFixed(3).replace(".", ".") + " M";
    }
  };

  const initialLevelIndex = userLevelss.findIndex(
    (level) => tapBalance < level.tapBalanceRequired
  );
  const currentLevelIndex =
    initialLevelIndex === -1 ? userLevelss.length - 1 : initialLevelIndex;

  const displayedLevelIndex = currentLevelIndex;
  const currentLevel = userLevelss[displayedLevelIndex];

  return (
    <>
      <Animate>
        <div className="w-full justify-center flex-col space-y-6">
          <div className="w-full flex items-center justify-between h-[55px] px-4 bg-[#000]  border-b border-b-[2px] border-b-[#a71414]">
            <div className="w-[50%] flex items-center space-x-[6px]">
              <div
                className={`w-[30px] h-[30px] bg-${selectedCharacter.class} rounded-[8px] p-[2px] overflow-hidden flex items-center justify-center relative`}
              >
                <img
                  src={currentLevel.icon}
                  className={`w-[30px]`}
                  alt={fullName || "user"}
                />
              </div>

              <div className="w-[70%] flex flex-col space-y-1 pr-4">
                <div className="w-full flex justify-between text-[10px] font-medium items-center">
                  <span className="levelName flex items-center">
                    <span onClick={() => setShowLevel(true)} className="">
                      {currentLevel.name}
                    </span>
                    <span className="flex items-center">
                      {" "}
                      <RiArrowRightSLine size={12} className="mt-[1px]" />{" "}
                    </span>
                  </span>

                  <span className="">Cheesy {username}</span>
                </div>

                <div className="flex w-full mt-2 items-center bg-[#56565630] rounded-[10px] border-[1px] border-[#49494952]">
                  <div
                    className={`h-[6px] rounded-[8px] levelbar`}
                    style={{
                      width: `${
                        (tapBalance / currentLevel.tapBalanceRequired) * 100
                      }%`,
                    }}
                  />
                </div>
              </div>
            </div>

            <div className="flex w-[50%] mb-[-4px] rounded-full items-center justify-end">
              <div className="flex flex-col items-center justify-center">
                <p className="text-[9px]">Balance</p>
                <div className="flex items-center justify-center space-x-1 text-[11px]">
                  <span className="flex items-center justify-center">
                    <img src="/coin.webp" alt="ppf" className="w-[10px]" />
                  </span>
                  <span className="font-bold">
                    {formatNumber(balance + refBonus)}
                  </span>
                </div>
              </div>
            </div>
          </div>

          <div className="w-full px-4 flex flex-col space-y-5">
            <div className="w-full flex items-center justify-between">
              <div
                onClick={() => handleMenu(1)}
                className={`${
                  activeIndex === 1 ? "bg-cards text-accent" : "text-[#ebebeb]"
                }  rounded-[6px] py-[10px] px-3 w-[45%] flex space-x-2 justify-center text-center text-[15px] font-medium items-center`}
              >
                <PiNotebook size={16} className="" />
                <span className="text-[#ebebeb]">Tasks</span>
              </div>

              <div
                onClick={() => handleMenu(2)}
                className={`${
                  activeIndex === 2 ? "bg-cards text-accent" : "text-[#ebebeb]"
                }  rounded-[6px] py-[10px] px-3 w-[45%] space-x-2 font-medium text-[15px] flex justify-center text-center items-center`}
              >
                <FaBoxes size={16} className="" />
                <span className="text-[#ebebeb]">Referrals</span>
              </div>
            </div>

            <div className={`${activeIndex === 1 ? "block" : "hidden"}`}>
              <h1 className="text-[20px] font-semibold">Earn more</h1>
              <p className="text-[14px] leading-[24px]">
                Perform tasks daily to earn more and level up real
                quick!
              </p>
            </div>

            <div className={`${activeIndex === 2 ? "block" : "hidden"}`}>
              <h1 className="text-[20px] font-semibold">
                Invite friends & earn more tokens
              </h1>
              <p className="text-[14px] text-[#c6c6c6] leading-[24px]">
                References grant an additional 3% bonus points, and earned
                points are processed automatically. Plus, earn 30 roulette spins
                and 10 Gold Hand spins for each referral!
              </p>
            </div>

            <div
              id="refer"
              className="w-full relative h-auto max-h-[60vh] overflow-y-auto scroller"
            >
              {/* tasks */}
              <div
                className={`${
                  activeIndex === 1 ? "block" : "hidden"
                } w-full flex items-end justify-center flex-col space-y-4`}
              >
                {taskLists
                  .sort((a, b) => a.id - b.id)
                  .map((task) => {
                    const userTask = tasks.find((t) => t.taskId === task.id);
                    const isTaskCompleted =
                      task?.userCompletions?.[userId]?.completed;
                    const isTaskSaved = !!userTask;
                    const hasPerformed = performedTasks[task.id];
                    return (
                      <>
                        <div
                          key={task.id}
                          className="w-full rounded-[16px] bg-[#000]  border border-[2px] border-[#a71414] p-4 pl-3 flex items-start space-x-2"
                        >
                          <div className="flex items-center justify-center">
                            <img
                              alt=""
                              src={`${task.icon}`}
                              className="w-[40px]"
                            />
                          </div>
                          <div className="flex h-full w-full flex-col justify-center relative">
                            <div className="flex w-full flex-col justify-between h-full space-y-1">
                              <h1 className="text-[15px] text-nowrap line-clamp-1 mr-[5px] font-medium">
                                {task.title}
                              </h1>
                              <div className="flex flex-wrap items-center w-full gap-3">
                                {task.slotSpin > 0 && (
                                  <span className="flex text-primary items-center w-fit space-x-1 text-[14px] font-semibold">
                                    <span
                                      className={`w-[10px] h-[10px] bg-accent rounded-full flex items-center`}
                                    ></span>
                                    <span className="">
                                      {task.slotSpin} Slot Spins
                                    </span>
                                  </span>
                                )}
                                {task.multiplierPoint > 0 && (
                                  <span className="flex text-primary items-center w-fit space-x-1 text-[14px] font-semibold">
                                    <span
                                      className={`w-[10px] h-[10px] bg-accent rounded-full flex items-center`}
                                    ></span>
                                    <span className="">
                                      {task.multiplierPoint} Multiplier Points
                                    </span>
                                  </span>
                                )}
                                {task.rouletteSpin > 0 && (
                                  <span className="flex text-primary items-center w-fit space-x-1 text-[14px] font-semibold">
                                    <span
                                      className={`w-[10px] h-[10px] bg-accent rounded-full flex items-center`}
                                    ></span>
                                    <span className="">
                                      {task.rouletteSpin} Roullete Spins
                                    </span>
                                  </span>
                                )}
                                {task.cheesePoint > 0 && (
                                  <span className="flex text-primary items-center w-fit space-x-1 text-[14px] font-semibold">
                                    <span
                                      className={`w-[10px] h-[10px] bg-accent rounded-full flex items-center`}
                                    ></span>
                                    <span className="">
                                      {task.cheesePoint} Cheese Points
                                    </span>
                                  </span>
                                )}
                              </div>
                              <h1 className="text-[15px] text-nowrap line-clamp-1 mr-[5px] font-medium">
                                Validity timeline: {task.validityPeriod || "0"}{" "}
                                days
                              </h1>

                              <div className="w-full flex items-center justify-between flex-wrap text-[14px] relative">
                                <>
                                  {!isTaskSaved && !isTaskCompleted && (
                                    <>
                                      <button
                                        onClick={() => performTask(task.id)}
                                        className="w-fit py-[6px] px-4 font-medium bg-cards hover:bg-[#8a8a8a] text-[#fff] hover:text-[#000] ease-in duration-200 rounded-[6px]"
                                      >
                                        Perform
                                      </button>
                                      <button
                                        onClick={() => verifyTask(task.id)}
                                        disabled={
                                          !hasPerformed || verifying[task.id]
                                        }
                                        className={`w-fit py-[6px] px-4 font-medium rounded-[6px] ${
                                          !hasPerformed
                                            ? "bg-btn2 text-[#888]"
                                            : "bg-btn4 text-[#000]"
                                        }`}
                                      >
                                        {verifying[task.id]
                                          ? "Verifying..."
                                          : "Verify"}
                                      </button>
                                    </>
                                  )}
                                </>

                                {/*  */}

                                {isTaskSaved && !isTaskCompleted && (
                                  <button
                                    onClick={() =>
                                      claimTask({
                                        id: task.id,
                                        roulette: task.rouletteSpin,
                                        slot: task.slotSpin,
                                        multiplier: task.multiplierPoint,
                                        cheese: task.cheesePoint,
                                      })
                                    }
                                    disabled={claiming[task.id]}
                                    className="w-fit py-[6px] px-4 font-medium bg-btn4 text-[#000] rounded-[6px]"
                                  >
                                    {claiming[task.id]
                                      ? "Claiming..."
                                      : "Claim"}
                                  </button>
                                )}

                                {isTaskCompleted && (
                                  <>
                                    <span className="w-fit py-[6px] px-4 font-medium bg-[#494949] text-[#b8b8b8] rounded-[6px]">
                                      Completed
                                    </span>
                                    <span className="mr-[6px]">
                                      <IoCheckmarkCircleSharp
                                        size={24}
                                        className="text-accent"
                                      />
                                    </span>
                                  </>
                                )}
                              </div>
                            </div>
                          </div>
                        </div>
                      </>
                    );
                  })}

                <ManualTasks />
              </div>

              {/* challenges */}

              <div
                className={`${
                  activeIndex === 2 ? "block" : "hidden"
                } w-full flex items-end !h-fit justify-center flex-col space-y-4`}
              >
                <Referrals />
              </div>
            </div>

            <div className="w-full absolute top-[50px] left-0 right-0 flex justify-center z-50 pointer-events-none select-none">
              {congrats ? (
                <img src="/congrats.gif" alt="congrats" className="w-[80%]" />
              ) : (
                <></>
              )}
            </div>

            <div
              className={`${
                modalOpen === true ? "visible" : "invisible"
              } fixed top-[-12px] bottom-0 left-0 z-40 right-0 h-[100vh] bg-[#00000042] flex justify-center items-center backdrop-blur-[10px] px-4`}
            >
              <div
                className={`${
                  modalOpen === true
                    ? "opacity-100 mt-0 ease-in duration-300"
                    : "opacity-0 mt-[100px]"
                } w-full bg-modal relative rounded-[16px] flex flex-col justify-center p-8`}
              >
                {modalMessage}

                <div className="w-full flex justify-center">
                  <button
                    onClick={closeModal}
                    className={`bg-btn4 w-fit py-[10px] px-6 flex items-center justify-center text-center rounded-[12px] font-medium text-[16px]`}
                  >
                    Continue tasks
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
        <Levels showLevel={showLevel} setShowLevel={setShowLevel} />
        <SettingsMenu
          showSetting={showSetting}
          setShowSetting={setShowSetting}
        />
        <Outlet />
      </Animate>
    </>
  );
};

export default TasksList;
